/**
 * Created by Todd Yu on 05/20/2020.
 * Description:
 * Admin Page Module for configuring routing for layout
 * ------ maintenance history ------
 * modified by Teddy Ding on 12/15/20
 * modified by Lucas Wang on 08/19/21
 */

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminPageLayoutComponent } from './admin-page-layout/admin-page-layout.component';
import { AdminPageGuard } from './admin-page.guard';
import { AdminIntralinksComponent } from './admin-page-content/admin-intralinks/admin-intralinks.component';
import { AdminGridPageComponent } from './admin-page-content/admin-grid-page/admin-grid-page.component';
import { AdminAutoTagPageComponent } from './admin-page-content/admin-autotag-page/admin-autotag-page.component';
import { AdminPageTypes } from '../../redux/reducers/admin-page.reducer';
import { AdminTemplateSettingsComponent } from './admin-page-content/admin-template-settings/admin-template-settings.component';
import { AdminWorkflowPageComponent } from './admin-page-content/admin-workflow-page/admin-workflow-page.component';
import { AdminGoogleMapServiceComponent } from './admin-page-content/admin-google-map-service/admin-google-map-service.component';
import { AdminExchangeServerComponent } from './admin-page-content/admin-exchange-server/admin-exchange-server.component';
import { CredentialService } from '../../tamalelibs/services/credential.service ';
import { AdminGeneralComponent } from './admin-page-content/admin-general/admin-general.component';
import { AdminEmailSettingComponent } from './admin-page-content/admin-email-setting/admin-email-setting.component';
import { AdminRelationshipsComponent } from './admin-page-content/admin-relationships/admin-relationships.component';
import { AdminNotificationsComponent } from './admin-page-content/admin-notifications/admin-notifications.component';
import { AdminPortfolioUploadComponent } from './admin-page-content/admin-portfolio-upload/admin-portfolio-upload.component';
import { AdminSystemConfigComponent } from './admin-page-content/admin-system-config/admin-system-config.component';
import { AdminSharedPageComponent } from './admin-page-content/admin-shared-page.component';
import { StoreCacheToFileComponent } from './admin-page-content/server-admin/store-cache-to-file.component';
import { PersistentCacheComponent } from './admin-page-content/server-admin/persistent-cache.component';
import { AdminCentralConfigComponent } from './admin-page-content/admin-central-config/admin-central-config.component';
import { ServerMonitoringComponent } from './admin-page-content/server-monitoring/server-monitoring.component';
import { ClamAVFileLookupComponent } from './admin-page-content/server-admin/clamav-file-lookup.component';

const routes: Routes = [
    {
        path: '',
        component: AdminPageLayoutComponent,
        canActivate: [AdminPageGuard],
        children: [
            { path: 'general', component: AdminGeneralComponent, data: { page: AdminPageTypes.GENERAL } },
            { path: 'users', component: AdminGridPageComponent, data: { page: AdminPageTypes.USERS } },
            { path: 'entry-types', component: AdminGridPageComponent, data: { page: AdminPageTypes.NOTE_TYPES } },
            { path: 'entity-types', component: AdminGridPageComponent, data: { page: AdminPageTypes.ENTITY_TYPES } },
            { path: 'relationships', component: AdminRelationshipsComponent, data: { page: AdminPageTypes.RELATIONSHIPS } },
            { path: 'notifications', component: AdminNotificationsComponent, data: { page: AdminPageTypes.NOTIFICATIONS } },
            { path: 'system-credentials', component: AdminGridPageComponent, data: { page: AdminPageTypes.SYSTEM_CREDENTIALS } },
            { path: 'auto-tag', component: AdminAutoTagPageComponent, data: { page: AdminPageTypes.AUTO_TAG } },
            { path: 'intralinks', component: AdminIntralinksComponent, data: { page: AdminPageTypes.INTRALINKS } },
            { path: 'exchange', component: AdminExchangeServerComponent, data: { page: AdminPageTypes.EXCHANGE } },
            { path: 'email-settings', component: AdminEmailSettingComponent, data: { page: AdminPageTypes.EMAIL_SETTINGS } },
            { path: 'workflow', component: AdminWorkflowPageComponent, data: { page: AdminPageTypes.WORKFLOW } },
            { path: 'template-settings', component: AdminTemplateSettingsComponent, data: { page: AdminPageTypes.TEMPLATE_SETTINGS } },
            { path: 'portfolio-upload', component: AdminPortfolioUploadComponent, data: { page: AdminPageTypes.PORTFOLIO_UPLOAD } },
            { path: 'system-config', component: AdminSystemConfigComponent, data: { page: AdminPageTypes.SYSTEM_CONFIG } },
            { path: 'central-config', component: AdminCentralConfigComponent, data: { page: AdminPageTypes.CENTRAL_CONFIG } },
            { path: 'google-map-service', component: AdminGoogleMapServiceComponent, data: { page: AdminPageTypes.GOOGLE_MAP_SERVICE } },
            { path: 'se-configuration', component: AdminSharedPageComponent, data: { page: AdminPageTypes.STREET_EVENTS_CONFIGURATION } },
            { path: 'etl-scheduled-jobs', component: AdminSharedPageComponent, data: { page: AdminPageTypes.ETL_SCHEDULED_JOBS } },
            { path: 'etl-tasks', component: AdminSharedPageComponent, data: { page: AdminPageTypes.ETL_Tasks } },
            { path: 'local-python-scripts', component: AdminSharedPageComponent, data: { page: AdminPageTypes.LOCAL_PYTHON_SCRIPTS } },
            { path: 'token-management', component: AdminSharedPageComponent, data: { page: AdminPageTypes.TOKEN_MANAGEMENT } },
            { path: 'store-cache-to-file', component: StoreCacheToFileComponent, data: { page: AdminPageTypes.STORE_CACHE_TO_FILE } },
            { path: 'persistent-cache', component: PersistentCacheComponent, data: { page: AdminPageTypes.PERSISTENT_CACHE } },
            { path: 'clamav-file-lookup', component: ClamAVFileLookupComponent, data: { page: AdminPageTypes.CLAMAV_FILE_LOOKUP } },
            { path: 'web-sites', component: AdminSharedPageComponent, data: { page: AdminPageTypes.WEB_SITES } },
            { path: 'server-monitoring', component: ServerMonitoringComponent, data: { page: AdminPageTypes.SERVER_MONITORING } },
            { path: '', redirectTo: 'general', pathMatch: 'full', data: { page: AdminPageTypes.GENERAL } },
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [
        CredentialService
    ]
})
export class AdminPageRoutingModule { }
